import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate, CanActivateChild, CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { filter, Observable, of, switchMap, take } from 'rxjs';
import {User} from "../../user/user.types";
import { StoreService } from '../../../ngrx/store.service';
import { selectConnectedUser } from '../../../ngrx/selectors/user.selectors';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class AcepPartnerGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(  private readonly _router: Router,
                private readonly storeService:StoreService,
                private  store: Store) {
  }
  canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl, state.url);
    return true;
  }

  /**
   * Can activate child
   *
   * @param childRoute
   * @param state
   */
  canActivateChild(
      childRoute: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl, state.url);
  }

  /**
   * Can load
   *
   * @param route
   * @param segments
   */
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const redirectUrl = route.path === 'sign-out' ? '/' : route.path;
    return this._check(redirectUrl, route.path);
  }

  private _check(redirectURL: string, path: string): Observable<boolean> {
    return this.store.select(selectConnectedUser).pipe(
      filter((curentUser) => curentUser !== undefined && curentUser !== null),
      take(1),
      switchMap((curentUser) => {
        // TODO: check if user has access to ACEP
        if (curentUser?.hasEPAccess || this.hasPageRoute(curentUser?.user_UserProfiles, path)) {
          return of(true);
        } else {
          console.log('ACEP Forbidden access');
          this._router.navigateByUrl('/forbidden-access');
          return of(false);
        }
      })
    );
  }

  hasPageRoute(user_UserProfiles: any[], targetRoute: string): boolean {
    if (!Array.isArray(user_UserProfiles)) {
      return false; // Return false if the input is not an array
    }
  
    return user_UserProfiles.some(user_UserProfiles => 
      user_UserProfiles?.userProfile?.permissions?.some(permission => 
        permission?.pageRoute === targetRoute
      )
    );
  }
  
  
}
